// extracted by mini-css-extract-plugin
export default {"container":"PiecePlayModeSelector_container__ZiDUz"};